<template>
    <div class="cms_fullwidth_lane">
        <GrcDialog2 ref="dialog" />
        <div class="cms_maincont_lane">
            Komponens tesztek
            <br><br>

            <div style="width:100%; box-sizing:border-box;">
                <GrcButton ref="btnTeszt"
                grc_text="popup teszt" @grc-click="btnTeszt_click" grc_readonly="false" 
                grc_style="cms_button_2"
                style="display:inline-block; width:auto;" />                    

                <GrcButton 
                grc_text="default" grc_readonly="false" 
                grc_style=""
                style="display:inline-block; width:auto; margin:8px;" />                    

                <GrcButton 
                grc_text="cms_button_1" grc_readonly="false" 
                grc_style="cms_button_1"
                style="display:inline-block; width:auto; margin:8px;" />                    

                <GrcButton 
                grc_text="cms_button_2" grc_readonly="false" 
                grc_style="cms_button_2"
                style="display:inline-block; width:auto; margin:8px;" />                    

                <GrcButton 
                grc_text="cms_button_3" grc_readonly="false" 
                grc_style="cms_button_3"
                style="display:inline-block; width:auto; margin:8px;" />                    

                <GrcButton 
                grc_text="cms_button_4" grc_readonly="false" 
                grc_style="cms_button_4"
                style="display:inline-block; width:auto; margin:8px;" />                    

                <GrcButton 
                grc_text="cms_button_5" grc_readonly="false" 
                grc_style="cms_button_5"
                style="display:inline-block; width:auto; margin:8px;" />                    

                <GrcButton 
                grc_text="cms_button_6" grc_readonly="false" 
                grc_style="cms_button_6"
                style="display:inline-block; width:auto; margin:8px;" />                    

                <GrcButton 
                grc_text="cms_button_7" grc_readonly="false" 
                grc_style="cms_button_7"
                style="display:inline-block; width:auto; margin:8px;" />                    

                <GrcButton 
                grc_text="cms_button_8" grc_readonly="false" 
                grc_style="cms_button_8"
                style="display:inline-block; width:auto; margin:8px;" />                    

            </div>
            
        </div>
    </div>
</template>


<script>

import Vue from 'vue';
import GrcDialog2 from '../GrcComponents/GrcDialog2.vue'
import GrcButton from '../GrcComponents/GrcButton.vue'

export default {
  name: 'frmteszt',
  components: {
    GrcDialog2,
    GrcButton,
  },
  data () {
      return {
        dlgtext:"",
      }
  },
  model: {

  },  
  methods:{
    btnTeszt_click()
    {
        let pTitle = "<i class='fal fa-info-circle' style='margin-right:6px;'></i>" + "Információ";
        let pText = "Mindenik embernek a lelkében dal van<br>És a saját lelkét hallja minden dalban<br>";
        this.dlgtext = this.dlgtext + pText + pText + pText;

        var params = { title: pTitle, text: this.dlgtext, color: grccomp_dialog_default_color(), width:500,
            buttons: [{text: "Rendben", value: "OK", style:"cms_button_7", width:"", default: true}
            ,{text: "Mégsem", value: "ESC", style:"cms_button_8", width:"", default: false}]
        };

        this.$refs.dialog.ShowDialog(params);




    },

  },
  created()
  {
    
  },

  mounted()
  {

  }

}


</script>


<style scoped>




@media (max-width:600px)
{

}



</style>